import * as React from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import UnselectedIcon from '@components/basics/icons/unselected';
import CircleArrowIcon from '@components/basics/icons/circle-arrow';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';
import MotionOpacity from '@components/motion/motion-opacity';
import { AnimatePresence } from 'framer-motion';

export interface RegionProps {
  className?: string;
  children?: any;
  title?: React.ReactNode;
  hasDropdown?: boolean;
  opened?: boolean;
  isChecked?: boolean;
  isGrey?: boolean;
  onChange?: (active: boolean) => void;
}

export const Region: React.FC<RegionProps> = (props) => {
  const [opened, setOpened] = React.useState(props.opened);

  React.useEffect(() => {
    setOpened(props.opened);
  }, [props.opened]);

  const toggleOpen = () => {
    const newValue = !opened;
    setOpened(newValue);
  };

  const handleChange = (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    ev.stopPropagation();
    if (props.onChange) {
      props.onChange(!props.isChecked);
    }
  };

  return (
    <div className={props.className} onClick={() => toggleOpen()}>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex justifyContent="flex-start" alignItems="center">
          {props.hasDropdown ? (
            <CircleArrowIcon
              className="icon dropdown"
              arrowUp={opened}
              darkCustomBgColor={props.isGrey}
            />
          ) : null}
          <Typography weight="700">{props.title}</Typography>
        </Flex>
        <AnimatePresence exitBeforeEnter>
          {props.isChecked ? (
            <MotionOpacity>
              <CompletedIcon
                onClick={(ev) => handleChange(ev)}
                className="icon check"
                noAnimation
              />
            </MotionOpacity>
          ) : (
            <MotionOpacity>
              <UnselectedIcon
                onClick={(ev) => handleChange(ev)}
                className="icon unselected"
                iconSize={24}
                noAnimation
              />
            </MotionOpacity>
          )}
        </AnimatePresence>
      </Flex>
      {opened && props.children ? (
        <div className="content">{props.children}</div>
      ) : null}
    </div>
  );
};

export default styled(Region)`
  margin-bottom: 14px;

  .icon {
    cursor: pointer;

    &.dropdown {
      margin-right: 12px;
    }
  }

  .content {
    margin-top: 16px;
  }
`;
